"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterializedPartnerJobCounts = void 0;
const account_status_enum_1 = require("../account-status-enum");
const job_status_enum_1 = require("../job-status-enum");
const partners_qualified_for_job_1 = require("../partners-qualified-for-job");
const typeorm_1 = require("typeorm/browser");
const user_role_enum_1 = require("../user-role-enum");
let MaterializedPartnerJobCounts = class MaterializedPartnerJobCounts {
};
__decorate([
    (0, typeorm_1.Index)('idx_partner_id'),
    (0, typeorm_1.Column)('varchar', {
        length: 18,
    }),
    __metadata("design:type", String)
], MaterializedPartnerJobCounts.prototype, "partnerId", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'shown_jobs',
        type: 'integer',
    }),
    __metadata("design:type", Number)
], MaterializedPartnerJobCounts.prototype, "shownJobs", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'potential_jobs',
        type: 'integer',
    }),
    __metadata("design:type", Number)
], MaterializedPartnerJobCounts.prototype, "potentialJobs", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'rejected_jobs',
        type: 'integer',
    }),
    __metadata("design:type", Number)
], MaterializedPartnerJobCounts.prototype, "rejectedJobs", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'completed_jobs',
        type: 'integer',
    }),
    __metadata("design:type", Number)
], MaterializedPartnerJobCounts.prototype, "completedJobs", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'active_jobs',
        type: 'integer',
    }),
    __metadata("design:type", Number)
], MaterializedPartnerJobCounts.prototype, "activeJobs", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'cancelled_jobs',
        type: 'integer',
    }),
    __metadata("design:type", Number)
], MaterializedPartnerJobCounts.prototype, "cancelledJobs", void 0);
MaterializedPartnerJobCounts = __decorate([
    (0, typeorm_1.ViewEntity)({
        materialized: true,
        dependsOn: [partners_qualified_for_job_1.PartnersQualifiedForJob],
        expression: `
    WITH open_jobs AS (
        SELECT
            pqfj.partner_id,
            COUNT(*) FILTER (
                WHERE CARDINALITY(pqfj.rejected_jobs) = 0
                AND NOT pqfj.in_rejected_opportunities
                AND NOT pqfj.in_rejected_brands
                AND NOT pqfj.in_rejected_services
                AND (pqfj.distance_from_job <= pqfj.partner_service_area OR pqfj.is_remote = TRUE)
            ) AS shown_jobs,
            COUNT(*) FILTER (
                WHERE CARDINALITY(pqfj.rejected_jobs) = 0
                AND NOT pqfj.in_rejected_opportunities
                AND NOT pqfj.in_rejected_brands
                AND NOT pqfj.in_rejected_services
                AND (pqfj.distance_from_job > pqfj.partner_service_area AND pqfj.is_remote = FALSE)
            ) AS potential_jobs,
            COUNT(*) FILTER (
                WHERE CARDINALITY(pqfj.rejected_jobs) > 0
                OR pqfj.in_rejected_opportunities
                OR pqfj.in_rejected_brands
                OR pqfj.in_rejected_services
            ) AS rejected_jobs
        FROM
            public.job__c job
        JOIN
            public.partners_qualified_for_job pqfj ON pqfj.job_sfid = job.sfid
        WHERE
            pqfj.partner_status IN (
              '${account_status_enum_1.AccountStatusEnum.ACTIVE}', '${account_status_enum_1.AccountStatusEnum.NEW}',
              '${account_status_enum_1.AccountStatusEnum.BEGINNER_ONBOARDING}',
              '${account_status_enum_1.AccountStatusEnum.REPEATED_ONBOARDING}'
            )
            AND job.status__c = '${job_status_enum_1.JobStatusEnum.OPEN}'
            AND job.test_order__c = FALSE
            AND job.professional__c IS NULL
        GROUP BY
            pqfj.partner_id
    ),
    taken_jobs AS (
        SELECT
            a.id AS partner_id,
            COUNT(*) FILTER (
              WHERE
                job.status__c IN (
                  '${job_status_enum_1.JobStatusEnum.FINISHED}', '${job_status_enum_1.JobStatusEnum.STARTED}',
                  '${job_status_enum_1.JobStatusEnum.APPOINTMENT_CONFIRMED}',
                  '${job_status_enum_1.JobStatusEnum.ACCEPTED}', '${job_status_enum_1.JobStatusEnum.ON_HOLD}'
                )
            ) AS active_jobs,
            COUNT(*) FILTER (
              WHERE
                job.status__c IN (
                  '${job_status_enum_1.JobStatusEnum.APPROVAL_PENDING}',
                  '${job_status_enum_1.JobStatusEnum.COMPLETED}', '${job_status_enum_1.JobStatusEnum.INVOICE_SENT}'
                )
            ) AS completed_jobs,
            COUNT(*) FILTER (
                WHERE job.status__c IN ('${job_status_enum_1.JobStatusEnum.CANCELLED}', '${job_status_enum_1.JobStatusEnum.CLOSED}')
            ) AS cancelled_jobs
        FROM
            public.job__c job
        JOIN
            public.account a ON a.id = job.professional__c
        WHERE
            job.test_order__c = FALSE
            AND job.professional__c IS NOT NULL
        GROUP BY
            a.id
    )
    SELECT
        a.id AS partner_id,
        COALESCE(oj.shown_jobs, 0) AS shown_jobs,
        COALESCE(oj.potential_jobs, 0) AS potential_jobs,
        COALESCE(oj.rejected_jobs, 0) AS rejected_jobs,
        COALESCE(tj.active_jobs, 0) AS active_jobs,
        COALESCE(tj.completed_jobs, 0) AS completed_jobs,
        COALESCE(tj.cancelled_jobs, 0) as cancelled_jobs
    FROM
        public.account a
    LEFT JOIN
        open_jobs oj ON a.id = oj.partner_id
    LEFT JOIN
        taken_jobs tj ON a.id = tj.partner_id
    WHERE a.role = '${user_role_enum_1.UserRoleEnum.PARTNER}'
  `,
        name: 'materialized_partner_job_counts',
        schema: 'public',
    })
], MaterializedPartnerJobCounts);
exports.MaterializedPartnerJobCounts = MaterializedPartnerJobCounts;
//# sourceMappingURL=materialized-partner-job-counts.js.map